import React, { useEffect } from "react";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";

import AddBeneficiaryPersonalDataForm from "./components/AddBeneficiaryPersonalDataForm";
import beneficiary from "../../gql/beneficiary";
import PatientDetailForm from "./components/PatientDetailForm";
import AppModal from "../../components/AppModal";
import toast from "react-hot-toast";
import BeneficiaryFormSkeleton from "../../common/BeneficiaryFormSkeleton";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

function EditBeneficiaryForm(props) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const location = useLocation();
  const item = location.state?.item ? location.state.item : null;

  const { loading, error, data, refetch } = useQuery(
    beneficiary.GET_PATIENT_BY_ID,
    {
      variables: { id: item?.id },
      fetchPolicy: "network-only",
    },
  );

  useEffect(() => {
    if (error?.graphQLErrors[0]?.message) {
      toast.error(error?.graphQLErrors[0]?.message);
    }
  }, [error]);

  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1); // Navigate back to the previous page
  };

  // if (loading) return <p>Loading...</p>;
  // if (error) return <p>Error: {error.message}</p>;

  return (
    <>
      {loading ? (
        <BeneficiaryFormSkeleton />
      ) : (
        <div className="superGit_container">
          <div className="benefeciary-create">
            <div className="shadow-sm rounded-[8px] border !mb-3 flex items-start gap-2 p-2">
              <div
                className="back flex items-center justify-center cursor-pointer transition-all duration-200 hover:opacity-80 active:scale-95"
                onClick={handleGoBack}
                style={{
                  backgroundColor: "#0070C2",
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                {i18n.language == "en" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g transform="scale(-1,1) translate(-24,0)">
                      <path
                        d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
                        fill="white"
                      />
                    </g>
                  </svg>
                )}
              </div>
              <div>
                <div className="text-[20px] font-bold ">
                  <span>{t("Edit Beneficiary")}</span>
                </div>
                <div className="text-[14px] text-[#667085]">
                  <span>{t("Edit beneficiary account details")}</span>
                </div>
              </div>
            </div>
            {/* <PatientDetailForm /> */}
            <AddBeneficiaryPersonalDataForm
              item={data?.getPatient?.data}
              refetchGetById={refetch}
            />
          </div>
          <AppModal isOpen={loading} />
        </div>
      )}
    </>
  );
  return <></>;
}

export default EditBeneficiaryForm;
